import { ISelectData } from 'components/atoms/SelectComponent';

export const zpusobZadani: ISelectData[] = [
    {
        value: 'SRD_NOVA_ZPUSOB_PRUVODCE',
        labelcz: 'SRD_NOVA_ZPUSOB_PRUVODCE'
    },
    {
        value: 'SRD_NOVA_ZPUSOB_XML',
        labelcz: 'SRD_NOVA_ZPUSOB_XML'
    }
];
